import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Leaf, Heart, Star, Clock, MapPin, Droplets, Crown, Mail, Phone, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useBooking } from '../contexts/BookingContext';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/y6uqcyxn_1683577696901.png";

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/eqxxqm1k_IMG-20251107-WA0008.jpg";
const AFRO_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/kviu8y7r_45534c89ec39ab5c3735a2ef1732c0a8.jpg";
const SPA_IMAGE = "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/73clugd0_IMG-20241118-WA0566.jpg";
const BODY_CARE_IMAGE = "https://customer-assets.emergentagent.com/job_23900c27-228f-4c3d-aeba-b97a1fc3d686/artifacts/rrnrx8ce_IMG-20241118-WA0471.jpg";
const SPA_FORMULAS_IMAGE = "https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/ox1bvdo6_e51d358ffbc33df7342dc87077298613.jpg";
const BEAUTY_IMAGE = "https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/a3s9eaxh_59bc170b50dbe6633dd71b4c3d031d87.jpg";

const serviceCategories = [
  {
    id: 'afro',
    title_pt: 'Afro Hair Studio',
    title_en: 'Afro Hair Studio',
    title_fr: 'Afro Hair Studio',
    title_de: 'Afro Hair Studio',
    title_es: 'Afro Hair Studio',
    description_pt: 'Tranças, extensões, tratamentos e muito mais para cabelo afro.',
    description_en: 'Braids, extensions, treatments and more for afro hair.',
    description_fr: 'Tresses, extensions, traitements et plus pour cheveux afro.',
    description_de: 'Zöpfe, Extensions, Behandlungen und mehr für Afro-Haar.',
    description_es: 'Trenzas, extensiones, tratamientos y más para cabello afro.',
    image: AFRO_IMAGE,
    link: '/afro-hair',
    icon: Sparkles,
  },
  {
    id: 'spa',
    title_pt: 'Massages',
    title_en: 'Massages',
    title_fr: 'Massages',
    title_de: 'Massagen',
    title_es: 'Masajes',
    description_pt: 'Massagens terapêuticas para relaxamento total e bem-estar.',
    description_en: 'Therapeutic massages for total relaxation and well-being.',
    description_fr: 'Massages thérapeutiques pour une relaxation totale et le bien-être.',
    description_de: 'Therapeutische Massagen für totale Entspannung und Wohlbefinden.',
    description_es: 'Masajes terapéuticos para relajación total y bienestar.',
    image: SPA_IMAGE,
    link: '/spa-wellness',
    icon: Leaf,
  },
  {
    id: 'bodycare',
    title_pt: 'Body Care',
    title_en: 'Body Care',
    title_fr: 'Soins Corporels',
    title_de: 'Körperpflege',
    title_es: 'Cuidado Corporal',
    description_pt: 'Tratamentos corporais, anti-celulite, modelagem e detox.',
    description_en: 'Body treatments, anti-cellulite, body shaping and detox.',
    description_fr: 'Soins corporels, anti-cellulite, remodelage et détox.',
    description_de: 'Körperbehandlungen, Anti-Cellulite, Körperformung und Detox.',
    description_es: 'Tratamientos corporales, anticelulíticos, modelado corporal y detox.',
    image: BODY_CARE_IMAGE,
    link: '/spa-wellness',
    icon: Droplets,
  },
  {
    id: 'formulas',
    title_pt: 'Spa Formulas',
    title_en: 'Spa Formulas',
    title_fr: 'Formules Spa',
    title_de: 'Spa-Formeln',
    title_es: 'Fórmulas Spa',
    description_pt: 'Pacotes exclusivos de bem-estar para uma experiência completa.',
    description_en: 'Exclusive wellness packages for a complete experience.',
    description_fr: 'Forfaits bien-être exclusifs pour une expérience complète.',
    description_de: 'Exklusive Wellness-Pakete für ein komplettes Erlebnis.',
    description_es: 'Paquetes de bienestar exclusivos para una experiencia completa.',
    image: SPA_FORMULAS_IMAGE,
    link: '/spa-wellness',
    icon: Crown,
  },
  {
    id: 'beauty',
    title_pt: 'Beauty & Aesthetics',
    title_en: 'Beauty & Aesthetics',
    title_fr: 'Beauté & Esthétique',
    title_de: 'Schönheit & Ästhetik',
    title_es: 'Belleza & Estética',
    description_pt: 'Manicure, pedicure, pestanas, sobrancelhas e maquilhagem.',
    description_en: 'Manicure, pedicure, lashes, brows and makeup.',
    description_fr: 'Manucure, pédicure, cils, sourcils et maquillage.',
    description_de: 'Maniküre, Pediküre, Wimpern, Augenbrauen und Make-up.',
    description_es: 'Manicura, pedicura, pestañas, cejas y maquillaje.',
    image: BEAUTY_IMAGE,
    link: '/services',
    icon: Heart,
  },
];

const testimonials = [
  {
    name: "Sofia M.",
    text_pt: "Adorei a experiência no IPRBC KAMIT! As tranças ficaram perfeitas e o ambiente é muito acolhedor. Recomendo a todos!",
    text_en: "Loved the experience at IPRBC KAMIT! The braids were perfect and the atmosphere is very welcoming. I recommend it to everyone!",
    text_fr: "J'ai adoré l'expérience chez IPRBC KAMIT ! Les tresses étaient parfaites et l'atmosphère est très accueillante. Je le recommande à tous !",
    text_de: "Ich habe die Erfahrung bei IPRBC KAMIT geliebt! Die Zöpfe waren perfekt und die Atmosphäre ist sehr einladend. Ich empfehle es allen!",
    text_es: "¡Me encantó la experiencia en IPRBC KAMIT! Las trenzas quedaron perfectas y el ambiente es muy acogedor. ¡Lo recomiendo a todos!",
    rating: 5,
  },
  {
    name: "Ana R.",
    text_pt: "Massagem incrível! A Esther é muito profissional e atenciosa. Saí completamente relaxada. Voltarei com certeza!",
    text_en: "Incredible massage! Esther is very professional and attentive. I left completely relaxed. I will definitely come back!",
    text_fr: "Massage incroyable ! Esther est très professionnelle et attentionnée. Je suis sortie complètement détendue. Je reviendrai certainement !",
    text_de: "Unglaubliche Massage! Esther ist sehr professionell und aufmerksam. Ich ging völlig entspannt. Ich werde auf jeden Fall wiederkommen!",
    text_es: "¡Masaje increíble! Esther es muy profesional y atenta. Salí completamente relajada. ¡Volveré sin duda!",
    rating: 5,
  },
  {
    name: "Carlos P.",
    text_pt: "O melhor spa da Madeira! Tratamentos de qualidade e preços justos. O ambiente é fantástico.",
    text_en: "The best spa in Madeira! Quality treatments and fair prices. The atmosphere is fantastic.",
    text_fr: "Le meilleur spa de Madère ! Soins de qualité et prix justes. L'atmosphère est fantastique.",
    text_de: "Das beste Spa auf Madeira! Qualitätsbehandlungen und faire Preise. Die Atmosphäre ist fantastisch.",
    text_es: "¡El mejor spa de Madeira! Tratamientos de calidad y precios justos. El ambiente es fantástico.",
    rating: 5,
  },
];

const HomePage = () => {
  const { t, language } = useLanguage();
  const { openBooking } = useBooking();
  const [businessInfo, setBusinessInfo] = useState(null);
  const [activePromotion, setActivePromotion] = useState(null);

  // Helper function to get localized text
  const getLocalizedText = (obj, field) => {
    if (!obj) return '';
    const key = `${field}_${language}`;
    return obj[key] || obj[`${field}_en`] || obj[`${field}_pt`] || '';
  };

  // UI translations for this page
  const pageTexts = {
    en: {
      whoWeAre: 'Who We Are',
      learnMore: 'Learn more',
      viewMore: 'View more',
      whatClientsSay: 'What Our Clients Say',
      seeAllReviews: 'See all Google Reviews',
      readyToRelax: 'Ready to Relax?',
      bookAppointment: 'Book your appointment today and discover the IPRBC KAMIT experience',
      aboutText1: 'The Professional Institute of Relaxation and Body Beauty is a space dedicated to well-being and beauty, combining ancestral African techniques with modern spa treatments.',
      aboutText2: 'Located on the beautiful island of Madeira, we offer a unique experience that celebrates the diversity and natural beauty of each client.'
    },
    fr: {
      whoWeAre: 'Qui Sommes-Nous',
      learnMore: 'En savoir plus',
      viewMore: 'Voir plus',
      whatClientsSay: 'Ce Que Disent Nos Clients',
      seeAllReviews: 'Voir tous les avis Google',
      readyToRelax: 'Prêt à Vous Détendre ?',
      bookAppointment: 'Réservez votre rendez-vous dès aujourd\'hui et découvrez l\'expérience IPRBC KAMIT',
      aboutText1: 'L\'Institut Professionnel de Relaxation et de Beauté Corporelle est un espace dédié au bien-être et à la beauté, combinant des techniques ancestrales africaines avec des soins spa modernes.',
      aboutText2: 'Situé sur la belle île de Madère, nous offrons une expérience unique qui célèbre la diversité et la beauté naturelle de chaque client.'
    },
    pt: {
      whoWeAre: 'Quem Somos',
      learnMore: 'Saber mais',
      viewMore: 'Ver mais',
      whatClientsSay: 'O Que Dizem os Nossos Clientes',
      seeAllReviews: 'Ver todas as avaliações Google',
      readyToRelax: 'Pronto para Relaxar?',
      bookAppointment: 'Reserve o seu encontro hoje e descubra a experiência IPRBC KAMIT',
      aboutText1: 'O Instituto Profissional de Relaxações e de Belezas Corporais é um espaço dedicado ao bem-estar e à beleza, combinando técnicas ancestrais africanas com tratamentos modernos de spa.',
      aboutText2: 'Localizado na bela ilha da Madeira, oferecemos uma experiência única que celebra a diversidade e a beleza natural de cada cliente.'
    },
    de: {
      whoWeAre: 'Wer Wir Sind',
      learnMore: 'Mehr erfahren',
      viewMore: 'Mehr anzeigen',
      whatClientsSay: 'Was Unsere Kunden Sagen',
      seeAllReviews: 'Alle Google-Bewertungen ansehen',
      readyToRelax: 'Bereit zum Entspannen?',
      bookAppointment: 'Buchen Sie noch heute Ihren Termin und entdecken Sie das IPRBC KAMIT Erlebnis',
      aboutText1: 'Das Professionelle Institut für Entspannung und Körperschönheit ist ein Raum für Wohlbefinden und Schönheit, der alte afrikanische Techniken mit modernen Spa-Behandlungen kombiniert.',
      aboutText2: 'Auf der wunderschönen Insel Madeira bieten wir ein einzigartiges Erlebnis, das die Vielfalt und natürliche Schönheit jedes Kunden feiert.'
    },
    es: {
      whoWeAre: 'Quiénes Somos',
      learnMore: 'Saber más',
      viewMore: 'Ver más',
      whatClientsSay: 'Lo Que Dicen Nuestros Clientes',
      seeAllReviews: 'Ver todas las reseñas de Google',
      readyToRelax: '¿Listo para Relajarte?',
      bookAppointment: 'Reserva tu cita hoy y descubre la experiencia IPRBC KAMIT',
      aboutText1: 'El Instituto Profesional de Relajación y Belleza Corporal es un espacio dedicado al bienestar y la belleza, combinando técnicas ancestrales africanas con tratamientos de spa modernos.',
      aboutText2: 'Ubicado en la hermosa isla de Madeira, ofrecemos una experiencia única que celebra la diversidad y la belleza natural de cada cliente.'
    }
  };
  const pt = pageTexts[language] || pageTexts.en;

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await axios.get(`${API}/business-info`);
        setBusinessInfo(response.data);
      } catch (error) {
        console.error('Error fetching business info:', error);
      }
    };
    
    const fetchActivePromotion = async () => {
      try {
        const response = await axios.get(`${API}/promotions/active`);
        if (response.data.promotion) {
          setActivePromotion(response.data.promotion);
        }
      } catch (error) {
        console.error('Error fetching active promotion:', error);
      }
    };
    
    fetchBusinessInfo();
    fetchActivePromotion();
  }, []);

  return (
    <div className="min-h-screen" data-testid="home-page">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        data-testid="hero-section"
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="IPRBC KAMIT Spa"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-kamit-dark/60 via-kamit-dark/40 to-kamit-dark/80" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <img 
            src={LOGO_URL} 
            alt="IPRBC KAMIT" 
            className="h-36 md:h-44 w-auto mx-auto mb-6 animate-fade-in-up"
          />
          
          <h1 
            className="font-heading text-4xl md:text-6xl text-kamit-beige mb-2 animate-fade-in-up stagger-1"
            style={{ opacity: 0, animationFillMode: 'forwards' }}
          >
            IPRBC KAMIT
          </h1>
          
          <p 
            className="text-kamit-gold text-2xl md:text-4xl mb-6 animate-fade-in-up stagger-2"
            style={{ opacity: 0, animationFillMode: 'forwards', fontFamily: "'Tangerine', cursive", fontWeight: 700 }}
          >
            Instituts Professionnels de Relaxations et de Beautés Corporelles
          </p>
          
          <p 
            className="text-2xl md:text-3xl text-kamit-beige/90 mb-4 font-heading animate-fade-in-up stagger-2"
            style={{ opacity: 0, animationFillMode: 'forwards' }}
          >
            {t('hero_title')}
          </p>
          
          <p 
            className="text-base md:text-lg text-kamit-beige/70 mb-8 max-w-2xl mx-auto font-light animate-fade-in-up stagger-3"
            style={{ opacity: 0, animationFillMode: 'forwards' }}
          >
            {t('hero_subtitle')}
          </p>
          
          <div 
            className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up stagger-3"
            style={{ opacity: 0, animationFillMode: 'forwards' }}
          >
            <a href="#" onClick={(e) => { e.preventDefault(); openBooking(); }}>
              <Button 
                size="lg" 
                className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-6 text-lg font-medium btn-shine"
                data-testid="hero-book-btn"
              >
                {t('hero_cta')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </a>
            <Link to="/services">
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-kamit-beige text-kamit-beige hover:bg-kamit-beige hover:text-kamit-dark rounded-full px-8 py-6 text-lg font-medium"
                data-testid="hero-services-btn"
              >
                {t('services_title')}
              </Button>
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-kamit-beige/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-kamit-beige/50 rounded-full" />
          </div>
        </div>
      </section>

      {/* Monthly Promotion Section */}
      {activePromotion && (
        <section className="py-16 bg-gradient-to-r from-kamit-gold/20 via-kamit-beige to-kamit-gold/20" data-testid="promo-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid md:grid-cols-2 gap-0">
                {/* Promo Image */}
                <div className="relative h-64 md:h-auto min-h-[300px]">
                  <img 
                    src={activePromotion.image || HERO_IMAGE}
                    alt={getLocalizedText(activePromotion, 'title')}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  {activePromotion.discount_value > 0 && (
                    <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold text-lg shadow-lg animate-pulse">
                      {activePromotion.discount_type === 'percentage' 
                        ? `-${activePromotion.discount_value}%` 
                        : `-${activePromotion.discount_value}€`
                      }
                    </div>
                  )}
                </div>
                
                {/* Promo Content */}
                <div className="p-8 md:p-12 flex flex-col justify-center bg-gradient-to-br from-kamit-brown to-kamit-dark text-white">
                  <div className="flex items-center gap-2 mb-4">
                    <Sparkles className="h-6 w-6 text-kamit-gold" />
                    <span className="text-kamit-gold font-semibold uppercase tracking-wider text-sm">
                      {language === 'fr' ? 'Offre Spéciale' : 
                       language === 'pt' ? 'Oferta Especial' : 
                       language === 'de' ? 'Sonderangebot' : 
                       language === 'es' ? 'Oferta Especial' : 'Special Offer'}
                    </span>
                  </div>
                  
                  <h2 className="text-3xl md:text-4xl font-heading text-white mb-4">
                    {getLocalizedText(activePromotion, 'title')}
                  </h2>
                  
                  <p className="text-kamit-beige/90 text-lg mb-6 leading-relaxed">
                    {getLocalizedText(activePromotion, 'description')}
                  </p>
                  
                  {activePromotion.promo_code && (
                    <div className="mb-6">
                      <span className="text-sm text-kamit-beige/70 block mb-2">
                        {language === 'fr' ? 'Code promo :' : 
                         language === 'pt' ? 'Código promocional:' : 
                         language === 'de' ? 'Promo-Code:' : 
                         language === 'es' ? 'Código promocional:' : 'Promo code:'}
                      </span>
                      <span className="inline-block bg-kamit-gold text-kamit-dark px-6 py-2 rounded-lg font-bold text-xl tracking-wider">
                        {activePromotion.promo_code}
                      </span>
                    </div>
                  )}
                  
                  <div className="flex flex-col sm:flex-row gap-4">
                    <button 
                      onClick={openBooking}
                      className="bg-kamit-gold hover:bg-white hover:text-kamit-dark text-kamit-dark px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                    >
                      {language === 'fr' ? 'Réserver Maintenant' : 
                       language === 'pt' ? 'Reservar Agora' : 
                       language === 'de' ? 'Jetzt Buchen' : 
                       language === 'es' ? 'Reservar Ahora' : 'Book Now'}
                      <ArrowRight className="h-5 w-5" />
                    </button>
                    
                    <Link 
                      to="/promotions"
                      className="border-2 border-kamit-gold text-kamit-gold hover:bg-kamit-gold hover:text-kamit-dark px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2"
                    >
                      {language === 'fr' ? 'Voir Toutes les Offres' : 
                       language === 'pt' ? 'Ver Todas as Ofertas' : 
                       language === 'de' ? 'Alle Angebote' : 
                       language === 'es' ? 'Ver Todas las Ofertas' : 'View All Offers'}
                    </Link>
                  </div>
                  
                  {/* Validity dates */}
                  <p className="mt-6 text-sm text-kamit-beige/60">
                    {language === 'fr' ? 'Valable du' : 
                     language === 'pt' ? 'Válido de' : 
                     language === 'de' ? 'Gültig vom' : 
                     language === 'es' ? 'Válido del' : 'Valid from'} {activePromotion.start_date} {language === 'fr' ? 'au' : 
                     language === 'pt' ? 'até' : 
                     language === 'de' ? 'bis' : 
                     language === 'es' ? 'hasta' : 'to'} {activePromotion.end_date}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Services Overview */}
      <section className="py-24 bg-kamit-cream" data-testid="services-overview">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl text-kamit-brown mb-4">
              {t('services_title')}
            </h2>
            <div className="w-24 h-1 bg-kamit-gold mx-auto" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 lg:gap-6">
            {serviceCategories.map((category, index) => {
              const IconComponent = category.icon;
              return (
                <Link 
                  key={category.id}
                  to={category.link}
                  className="group service-card rounded-2xl overflow-hidden bg-white shadow-lg border border-kamit-brown/10"
                  data-testid={`service-card-${category.id}`}
                >
                  <div className="relative h-40 lg:h-48 overflow-hidden">
                    <img 
                      src={category.image}
                      alt={getLocalizedText(category, 'title')}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-kamit-brown/70 to-transparent" />
                    <div className="absolute bottom-3 left-3 right-3">
                      <div className="flex items-center gap-2 text-kamit-gold">
                        <IconComponent className="h-4 w-4" />
                        <span className="text-xs uppercase tracking-wider text-white">
                          {getLocalizedText(category, 'title')}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 bg-white">
                    <h3 className="font-heading text-lg text-kamit-brown mb-1">
                      {getLocalizedText(category, 'title')}
                    </h3>
                    <p className="text-kamit-brown/70 mb-3 text-xs line-clamp-2">
                      {getLocalizedText(category, 'description')}
                    </p>
                    <span className="inline-flex items-center text-kamit-gold font-medium text-xs group-hover:gap-1 transition-all">
                      {pt.viewMore}
                      <ArrowRight className="ml-1 h-3 w-3 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-24 bg-kamit-cream" data-testid="about-preview">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-kamit-gold uppercase tracking-widest text-sm">
                {pt.whoWeAre}
              </span>
              <h2 className="font-heading text-4xl md:text-5xl text-kamit-brown mt-2 mb-6">
                IPRBC KAMIT
              </h2>
              <p className="text-kamit-brown/70 leading-relaxed mb-6">
                {pt.aboutText1}
              </p>
              <p className="text-kamit-brown/70 leading-relaxed mb-8">
                {pt.aboutText2}
              </p>
              <Link to="/about">
                <Button className="bg-kamit-brown hover:bg-kamit-dark text-kamit-beige rounded-full px-8">
                  {pt.learnMore}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <div className="relative flex justify-center gap-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/jerf73bd_1_20260124_200727_0000.png"
                alt="IPRBC KAMIT Services Menu"
                className="rounded-2xl shadow-lg w-full max-w-sm h-auto object-contain"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_7f45736e-df57-4742-9820-4e4efb4e31c0/artifacts/6twl5xrt_IMG-20250302-WA0010.jpg"
                alt="IPRBC KAMIT Hair, Aesthetics & Wellness"
                className="rounded-2xl shadow-lg w-full max-w-sm h-auto object-contain hidden md:block"
              />
              {/* Decorative Element */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-kamit-gold/20 rounded-full blur-2xl" />
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-kamit-green/20 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-kamit-brown" data-testid="testimonials">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl text-kamit-beige mb-4">
              {pt.whatClientsSay}
            </h2>
            <div className="w-24 h-1 bg-kamit-gold mx-auto" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-kamit-dark/30 backdrop-blur-sm rounded-2xl p-8 border border-kamit-beige/10"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-kamit-gold text-kamit-gold" />
                  ))}
                </div>
                <p className="text-kamit-beige/90 italic mb-6 leading-relaxed">
                  "{getLocalizedText(testimonial, 'text')}"
                </p>
                <p className="text-kamit-gold font-medium">{testimonial.name}</p>
              </div>
            ))}
          </div>
          
          {/* Google Reviews CTA */}
          <div className="text-center mt-12">
            <a 
              href="https://www.google.com/search?kgmid=/g/11y8tg20zx&q=IPRBC+KAMIT"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="outline" className="border-2 border-kamit-beige text-kamit-beige hover:bg-kamit-beige hover:text-kamit-dark rounded-full px-8">
                <Star className="mr-2 h-4 w-4" />
                {pt.seeAllReviews}
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="py-12 bg-kamit-cream border-t border-kamit-brown/10" data-testid="quick-links">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center items-center gap-6">
            <span className="text-kamit-brown/60 text-sm font-medium uppercase tracking-wider">Quick Links:</span>
            <Link 
              to="/admin" 
              className="flex items-center gap-2 bg-kamit-brown text-kamit-beige px-5 py-2.5 rounded-full hover:bg-kamit-dark transition-all shadow-md hover:shadow-lg"
              data-testid="quick-link-admin"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <span className="font-medium">Admin</span>
            </Link>
            <a 
              href="mailto:iprbckamit@gmail.com" 
              className="flex items-center gap-2 bg-kamit-gold/20 text-kamit-brown px-5 py-2.5 rounded-full hover:bg-kamit-gold/30 transition-all border border-kamit-gold/30"
            >
              <Mail className="h-5 w-5" />
              <span className="font-medium">Email</span>
            </a>
            <a 
              href="tel:+351935984047" 
              className="flex items-center gap-2 bg-kamit-gold/20 text-kamit-brown px-5 py-2.5 rounded-full hover:bg-kamit-gold/30 transition-all border border-kamit-gold/30"
            >
              <Phone className="h-5 w-5" />
              <span className="font-medium">Appeler</span>
            </a>
            <a 
              href="https://wa.me/351935984047" 
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-500/20 text-green-700 px-5 py-2.5 rounded-full hover:bg-green-500/30 transition-all border border-green-500/30"
            >
              <MessageCircle className="h-5 w-5" />
              <span className="font-medium">WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-24 bg-kamit-beige" data-testid="contact-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-4xl md:text-5xl text-kamit-brown mb-6">
            {pt.readyToRelax}
          </h2>
          <p className="text-kamit-brown/70 mb-8 text-lg">
            {pt.bookAppointment}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
            <Button 
              size="lg"
              onClick={() => openBooking()}
              className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-10 py-6 text-lg btn-shine"
              data-testid="cta-book-btn"
            >
              {t('nav_book')}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Link to="/contact">
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-kamit-brown text-kamit-brown hover:bg-kamit-brown hover:text-kamit-beige rounded-full px-10 py-6 text-lg"
              >
                {t('nav_contact')}
              </Button>
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-kamit-brown/70">
            <div className="flex items-center gap-2">
              <MapPin className="h-5 w-5 text-kamit-gold" />
              <span>Santa Luzia, Madeira</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="h-5 w-5 text-kamit-gold" />
              <span>Seg-Sáb: 9:00-19:00</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
